import API from 'js/lib/api';

import constants from 'bundles/s12n-common/service/constants';

export default API(constants.s12nMembershipsApi, {
  type: 'rest',
});
